<template>

  <div class="pop_tit i-bar" :class="[type]">
    <!-- icon 이 지정되면 무조건 표시 -->
    <span v-if="icon" v-html="icon" class="pr-1"></span>

    <!-- title이 있고 아이콘 지정 없으면 기본 아이콘 표시 -->
    <!-- <span v-else-if="title">📁</span> -->
    <!--💼 📁📂📍✔🔘• ➕ ➖⏹ 💡📂🗒 📎-->

    <span v-html="title" class="tit"></span>
    <slot name="append"></slot>
    <!-- <span x-spacer></span> -->
    <span class="right">
      <slot></slot>
    </span>
  </div>
</template>

<style>
div.i-bar {
    padding: 15px 0px 15px 0;
    background-size: 100% 100%;
}

div.i-bar.normal {
    background: #1f8ae4 url(/images/common/bg_grade_top.png) 50% 50% no-repeat;
    color: #fff;
}
div.i-bar.error {
    background-color: red;
    color: #fff;
}

div.i-bar span.tit{
    padding: 15px 0px 15px 20px;
    font-size:20px;
    color: #fff;
  }

div.i-bar .btn { margin-right: 5px; background-color: white; padding:1px 0px 2px 0px; border-color:#007233; color:black; min-width:110px;}
div.i-bar .right { font-size: 16px; margin-top:-5px;}
div.i-bar .right .pop_close { margin-top:-12px;}

@media screen and (max-width:640px){
  div.i-bar span.tit{ font-size:17px; }

}
</style>


<script>
export default {
  props : {
    title: { },
    icon: { },
    type: { default: 'normal'},
  },
}
</script>
